<script lang="ts">
  import { Button, Col, Form, Input, Row } from "sveltestrap";
  import { COD, href, Submit } from "../../../../utils/Constant/Constant";
  import Card from "../../../Core/Card.svelte";
  import CodBody from "./CodBody.svelte";
</script>
<Col xxl="4" lg="6" class="box-col-6">
  <Card cardHeaderprops="pb-0" headerTitle={COD}>
    <div slot="contentbody">
      <CodBody />
    </div>
  </Card>
</Col>